import React, { Fragment, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import cryptoRandomString from "crypto-random-string";
import { RegisterContext } from "../context/register-context";
import { useTranslation } from "react-i18next";

import Button from "../UI/Button";
import Card from "../UI/Card";
// import LanguageDropDown from "../layout/LanguageDropDown";

// import classes from "./StartingPage.module.css";
import "./StartingPage.css";

const StartingPage = () => {
  // const subjectCodeInputRef = useRef();

  const history = useHistory();  

  // const [isInputValid, setIsInputValid] = useState(false);
  // const [isInputTouched, setIsInputTouched] = useState(false);
  // const [isFormCompleted, setIsFormCompleted] = useState(false);
  // const [error, setError] = useState();
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [isPolicyChecked, setIsPolicyChecked] = useState(false);

  // const [codeValue, setCodeValue] = useState("");

  const register = useContext(RegisterContext);

  // const uniqueUserId = cryptoRandomString({ length: 10, type: "alphanumeric" });

  const { t } = useTranslation();

  const formSubmissionHandler = async (event) => {
    event.preventDefault();
    const userCode = cryptoRandomString({ length: 10, type: "alphanumeric" });
    // const enteredSubjectCode = subjectCodeInputRef.current.value;

    // Send POST request to register a user
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/users/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userCode: userCode,
        }),
      });

      const responseData = await response.json();
      register.register(responseData.user.id);
      console.log(responseData);
      console.log(responseData.user.id);
    } catch (err) {
      register.unregister();
      console.log(err);
      // setError(err.message || "Something went wrong, please try again.");
    }

    // setIsInputTouched(true);

    // Validation of input
    // if (userCode.trim() === "") {
    //   setIsInputValid(false);

    //   return;
    // }

    // setIsInputValid(true);
    // setIsFormCompleted(true);
    history.replace("/page1");

    console.log(userCode);
  };

  const confirmCheckboxHandler = (event) => {
    // Validation
    console.log(event.target.checked);

    setIsPolicyChecked(event.target.checked);

    if (event.target.checked === false) {
      setBtnDisabled(true);
      return;
    }
    setBtnDisabled(false);
  };

  // const onChangeInputHandler = () => {
  //   setIsInputValid(true);
  //   console.log("Input is clicked!");
  // };

  // const inputIsInvalid = !isInputValid && isInputTouched;

  // const inputClasses = `${inputIsInvalid && classes.invalid_label}`;

  return (
    <Fragment>
      <h2 className="centered-header">{t("welcome_to_relaxation_laboratory")}</h2>
      
      <Card>
        {/* <h4>
        Bitte füllen Sie in Vorbereitung der Stressmessung das nachfolgende
        Formular aus um später eine Zuordnung während der Stressmessung gewährleisten zu können.
      </h4> */}
        {/* <img
        src="https://images.unsplash.com/photo-1429277096327-11ee3b761c93?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2048&q=80"
        alt="coverImage"
        width="400"
        height="300"
      /> */}
        {/* <h5>Bitte erstellen Sie Ihren persönlichen Code nach folgendem Aufbau</h5> */}
        {/* <ol>
        <li>Zweiter Buchstabe des eigenen Vornamens (z.B. "R" für Fritz)</li>
        <li>Letzter Buchstabe des eigenen Nachnamens (z.B. "T" für Schmidt)</li>
        <li>Erster Buchstabe des Vornamens des Vaters (z.B. "K" für Karl)</li>
        <li>
          Letzter Buchstabe des eigenen Geburtsortes (z.B. "G" für Freiburg)
        </li>
        <li>
          Monat des eigenen Geburtsdatums (z.B. "07" für 13.07.1986, bitte
          zweistellig angeben)
        </li>
      </ol> */}
        <h3 className="centered-header">{t("start_page_header")}</h3>
        <p>{t("privacy_content")}</p>
        <div>
          <input
            id="confirm"
            type="checkbox"
            value="confirm"
            onChange={confirmCheckboxHandler}
            checked={isPolicyChecked}
          />
          <label htmlFor="confirm">{t("agree")}</label>
          <span> *</span>
        </div>
        <form onSubmit={formSubmissionHandler}>
          <Button value={t("btn_start")} isDisabled={btnDisabled} />
        </form>
      </Card>
      
    </Fragment>
  );
};

export default StartingPage;
